/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_SPONSORS (state, sponsors) {
    state.sponsors = sponsors
  },
  REMOVE_RECORD (state, itemId) {
    const sponsorIndex = state.sponsors.findIndex((u) => u.SponsorId === itemId)
    state.sponsors.splice(sponsorIndex, 1)
  }
}
